import { default as React } from "react";

export const MODAL_SHOW = "MODAL_SHOW";
export const MODAL_HIDE = "MODAL_HIDE";

export interface ModalComponentProps {
    // Pokud bude posláno v propsech, tak se zavolá při zavření dialogu (ať už ze zavíracího tlačítka dialogu, tak ručně pomocí zavolání onClose v komponentě), v e je možné zavolat preventDefault pro zabránění automatickému zavření dialogu
    onClose: (e?: React.MouseEvent<HTMLElement>) => void;
}

export type ModalComponent = React.ComponentType<ModalComponentProps>;

export interface ModalItem {
    component: ModalComponent;
    componentProps?: ModalComponentProps;
}

export interface ModalState {
    components: ModalItem[];
}

export type IShow = {
    component: ModalComponent,
    componentProps?: ModalComponentProps
}
export type IHide = {}
